import { ApiContentType, ApiModel } from 'api/base';
import getApi from 'api/base/get-api';

const { REACT_APP_PRODUCTS_API } = process.env;
const endpoint = `${REACT_APP_PRODUCTS_API}/rate/`;

const rateApi: ApiModel<{ name: string; value: number }> = getApi(endpoint, ApiContentType.MULTIPART, 'name');

export default rateApi;
